export class FreeRoundsScreenEvents {
	public static readonly FREE_GAMES_STARTED: string = 'FreeRoundsScreenEvents::FREE_GAMES_STARTED';
	public static readonly FREE_GAMES_RESUMED: string = 'FreeRoundsScreenEvents::FREE_GAMES_RESUMED';

	public static readonly FREE_GAMES_FINISHED: string = 'FreeRoundsScreenEvents::FREE_GAMES_FINISHED';
	public static readonly FREE_GAMES_POSTPONED: string = 'FreeRoundsScreenEvents::FREE_GAMES_POSTPONED';
	public static readonly FREE_GAMES_REJECTED: string = 'FreeRoundsScreenEvents::FREE_GAMES_REJECTED';
	public static readonly FREE_GAME_EXPIRED: string = 'FreeRoundsScreenEvents::FREE_GAME_EXPIRED';

	public static readonly FREE_GAMES_NEXT_OFFER: string = 'FreeRoundsScreenEvents::FREE_GAMES_NEXT_OFFER';

	public static readonly RESTORE_TO_IN_GAME: string = 'FreeRoundsScreenEvents::RESTORE_TO_IN_GAME';

	public static readonly FREE_ROUNDS_SCREEN_SHOWN: string = 'FreeRoundsScreenEvents::FREE_ROUNDS_SCREEN_SHOWN';
	public static readonly FREE_ROUNDS_SCREEN_HIDDEN: string = 'FreeRoundsScreenEvents::FREE_ROUNDS_SCREEN_HIDDEN';

	public static readonly EXPECTED_TO_SHOW_FREE_ROUNDS_WINDOW: string = 'FreeRoundsScreenEvents::EXPECTED_TO_SHOW_FREE_ROUNDS_WINDOW';

	public static readonly SOON_WILL_SHOW_FREE_ROUNDS_END: string = 'FreeRoundsScreenEvents::SOON_WILL_SHOW_FREE_ROUNDS_END';
}


// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/modules/microgaming/freerounds/FreeRoundsScreenEvents.ts